import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Logo from "./assets/images/nav_logo.png";

// Form Component with all functionality
const FormPopup = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    college_name: "",
    year_of_student: "",
  });

  const [allData, setAllData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setIsSubmitting(true);

    const currentDate = new Date();
    const offsetInMinutes = currentDate.getTimezoneOffset() + 330;
    const currentISTTime = new Date(currentDate.getTime() + offsetInMinutes * 60 * 1000);

    const options = { 
      year: "numeric", 
      month: "2-digit", 
      day: "2-digit", 
      hour: "2-digit", 
      minute: "2-digit", 
      second: "2-digit", 
      hour12: true
    };
    
    const formattedDateTime = currentISTTime.toLocaleString("en-IN", options);

    const newData = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      college_name: formData.college_name,
      year_of_student: formData.year_of_student,
      date_and_time: formattedDateTime,
    };

    console.log("Data to be submitted:", newData);

    try {
      const response = await fetch('https://sheetdb.io/api/v1/ydgx2yzqvb8em', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Result from SheetDB API:", result);

        setAllData([...allData, newData]);
        setFormData({
          name: "",
          email: "",
          phone: "",
          college_name: "",
          year_of_student: "",
        });

        // ❌ REMOVED popupShown storage (this was stopping popup forever)
        // sessionStorage.setItem('popupShown', 'true');

        // Open Thank You page in new tab
        window.open('/Thankyou', '_blank');

        const link = document.createElement('a');
        // link.href = '/RoboAi-Brochure.pdf';
        // link.download = 'RoboAi-Brochure.pdf';
        link.click();

        onClose();
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      overflow: 'auto'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '12px',
        maxWidth: '450px',
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '20px'
        }}>
        <div className="overview-form-top01" style={{
          display: 'flex',
          alignItems: 'start',
        }}>
        <div className="form-logo main-index">
          <img src={Logo} className="form-logo-img" alt="Form Logo" />
        </div>
        <span className="text-want" style={{
          alignItems: 'start',
        }}>Want to<br />Download brochure?</span>
      </div>  
          <button className='close-button'
            onClick={onClose}>
            ✕
          </button>
        </div>
        
        <form className='popup-form-content' onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
            disabled={isSubmitting}
            style={{
              padding: '12px',
              border: '2px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.3s',
              opacity: isSubmitting ? 0.6 : 1
            }}
            onFocus={(e) => e.target.style.borderColor = '#007bff'}
            onBlur={(e) => e.target.style.borderColor = '#ddd'}
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            disabled={isSubmitting}
            style={{
              padding: '12px',
              border: '2px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.3s',
              opacity: isSubmitting ? 0.6 : 1
            }}
            onFocus={(e) => e.target.style.borderColor = '#007bff'}
            onBlur={(e) => e.target.style.borderColor = '#ddd'}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone"
            maxLength={10}
            value={formData.phone}
            onChange={handleChange}
            required
            disabled={isSubmitting}
            style={{
              padding: '12px',
              border: '2px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.3s',
              opacity: isSubmitting ? 0.6 : 1
            }}
            onFocus={(e) => e.target.style.borderColor = '#007bff'}
            onBlur={(e) => e.target.style.borderColor = '#ddd'}
          />
          <input
            type="text"
            name="college_name"
            placeholder="College Name"
            value={formData.college_name}
            onChange={handleChange}
            required
            disabled={isSubmitting}
            style={{
              padding: '12px',
              border: '2px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.3s',
              opacity: isSubmitting ? 0.6 : 1
            }}
            onFocus={(e) => e.target.style.borderColor = '#007bff'}
            onBlur={(e) => e.target.style.borderColor = '#ddd'}
          />
          <select
            name="year_of_student"
            onChange={handleChange}
            value={formData.year_of_student}
            required
            disabled={isSubmitting}
            style={{
              padding: '12px',
              border: '2px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px',
              outline: 'none',
              backgroundColor: 'white',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              transition: 'border-color 0.3s',
              opacity: isSubmitting ? 0.6 : 1
            }}
            onFocus={(e) => e.target.style.borderColor = '#007bff'}
            onBlur={(e) => e.target.style.borderColor = '#ddd'}
          >
            <option value="">Year of Study</option>
            <option value="1st year">1st year</option>
            <option value="2nd year">2nd year</option>
            <option value="3rd year">3rd year</option>
            <option value="4th year">4th year</option>
            <option value="Working professional">Working professional</option>
            <option value="Others">Others</option>
          </select>
          <button 
            type="submit"
            disabled={isSubmitting}
            style={{
              padding: '15px',
              backgroundColor: isSubmitting ? '#FF6F00' : '#FF6F00',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.3s',
              marginTop: '10px',
              opacity: isSubmitting ? 0.6 : 1
            }}
            onMouseOver={(e) => {
              if (!isSubmitting) {
                e.target.style.backgroundColor = '#e1c818';
              }
            }}
            onMouseOut={(e) => {
              if (!isSubmitting) {
                e.target.style.backgroundColor = '#e1c818';
              }
            }}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

// Main Wrapper Component
const AppWithPopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  React.useEffect(() => {
    // Check if we're on Thankyou page
    const isThankYouPage = window.location.pathname.includes('/Thankyou');

    // ❌ popupShown check removed — popup always works
    // ❌ const popupAlreadyShown = sessionStorage.getItem('popupShown') === 'true';

    if (!isThankYouPage) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      <App />
      <FormPopup
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
      />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWithPopup />
  </React.StrictMode>
);

reportWebVitals();
